import { render } from "./ContactTracingTable.vue?vue&type=template&id=a37aa1ba&scoped=true"
import script from "./ContactTracingTable.vue?vue&type=script&lang=js"
export * from "./ContactTracingTable.vue?vue&type=script&lang=js"

import "./ContactTracingTable.vue?vue&type=style&index=0&id=a37aa1ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37aa1ba"]])

export default __exports__